module.exports = __webpack_public_path__ + "img/goodw2.c52ff05c.png";